// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"NewsSummary-module--imageContainer--htM1L"};